















import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Clue extends Vue {
  @Prop() private start!: Date;
  @Prop() private title!: string;
  @Prop() private message!: string;
  @Prop() private image?: string;

  get startDisplayable() {
    return moment(this.start).format('YYYY-MM-DD HH:mm:ss');
  }
}
